import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Helpers } from 'src/helpers/helpers';
import { BaseService } from './base.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FeeService extends BaseService {

  constructor(private http: HttpClient,  helper: Helpers) {
    super(helper);
 }

 private pathAPI = environment.apiUrl;

  getFees(): any {
    return this.http.get<any>(this.pathAPI + 'fee', super.header()).pipe(catchError(super.handleError));
  }

  updateFee(data: any): any {
    return this.http.post<any>(this.pathAPI + 'fee', data, super.header()).pipe(catchError(super.handleError));
  }
}
